<div class="broker-details-grid-container">
  <div class="broker-details-header-section">
    <div class="broker-details-header-left-section">
      <p class="broker-details-grid-title">Broker Detail</p>
    </div>
    <div class="broker-details-header-right-section">
      <va-button
        btnType="outline"
        size="medium"
        (onClick)="hanldeColumnPickerClick()"
        [isDisabled]="
          isBrokerDetailsGridApiInProgress ||
          isTprColumnDetailsSaveApiInProgress
        "
        title="Column Picker"
        >Column Picker</va-button
      >
      <app-export-to-excel-dropdown
        class="export-button"
        [(isPopoverVisible)]="isExportPopoverVisible"
        [disabled]="
          isBrokerDetailsGridApiInProgress ||
          isTprColumnDetailsSaveApiInProgress
        "
        [optionList]="excelToExportDropdownOptions"
        [isExportInProgress]="isExportInProgress"
        (onListItemClick)="handleETEListItemClick($event)"
      ></app-export-to-excel-dropdown>
    </div>
  </div>
  <div class="broker-details-grid">
    <va-custom-grid
      (sortChange)="handleCompanyBrokerDetailStortChange($event)"
      [columnsData]="gridColumnsData"
      [data]="gridData"
      [fields]="gridFields"
      [widthConfig]="gridColumnWidthConfig"
      [columnFreezeConfig]="gridColumnFreezeConfig"
      [bordered]="true"
      [loading]="isBrokerDetailsGridApiInProgress"
      [loadingListItems]="6"
      gridHeight="748px"
      [selectedCellId]="selectedCellId"
      [selectedRowId]="selectedRowId"
      [showPagination]="false"
    ></va-custom-grid>
    <div
      *ngIf="!isBrokerDetailsGridApiInProgress && notEntitledSourceMessage"
      class="broker-details-grid-entitlement-message"
    >
      {{ notEntitledSourceMessage }}
    </div>
    <div *ngIf="!isBrokerDetailsGridApiInProgress" class="factset-message">
      {{ individualContributorDisclaimers }}<br />
      <span style="color: #b0b0b0">{{ factsetCopyRightMessage }}</span>
    </div>
  </div>
</div>

<!-- Filing modal -->
<nz-modal
  [(nzVisible)]="isFilingModalVisible"
  [nzFooter]="null"
  nzWidth="800px"
  (nzOnCancel)="handleFilingModalCancel()"
  [nzTitle]="filingsHeading"
  [nzStyle]="{ top: '20px' }"
>
  <ng-container *nzModalContent>
    <div style="height: 480px" *ngIf="gettingPDFURL"></div>
    <div class="pagination-bar">
      <div class="doc-details">
        <div class="doc-type">
          <div class="detail-title">Document Type:</div>
          <div class="detail-value">{{ documentType }}</div>
        </div>
        <div class="date-pub">
          <div class="detail-title">Date Published:</div>
          <div class="detail-value">{{ datePublish }}</div>
        </div>
      </div>
      <div class="guidance-navigation" *ngIf="hasGuidance">
        <div class="guidance-title">
          <va-icon
            [name]="'guidance'"
            size="medium"
            class="data-setting-icon guidance-icon"
          ></va-icon>
          Guidance
        </div>
        <div class="guidance-navigator">
          <va-icon
            [name]="'chevron-left'"
            class="data-setting-icon navigator-element"
            size="small"
            (click)="onPrevGuidance()"
          ></va-icon>
          <div class="guidance-index">
            {{ currentGuidance }}
          </div>
          <div class="navigator-element">/</div>
          <div class="guidance-count navigator-element">
            {{ guidanceCount }}
          </div>
          <va-icon
            [name]="'chevron-right'"
            class="data-setting-icon navigator-element"
            size="small"
            (click)="onNextGuidance()"
          ></va-icon>
        </div>
      </div>
    </div>
    <iframe
      [src]="viewFilingModalSrc"
      id="filingsFrame"
      frameborder="0"
      allowfullscreen
      width="100%"
      height="480px"
      *ngIf="filingFileType === 'pdf' && !filingsError && !gettingPDFURL"
    ></iframe>
    <iframe
      id="filingsFrame"
      frameborder="0"
      allowfullscreen
      width="100%"
      height="480px"
      *ngIf="
        (filingFileType === 'htm' || filingFileType === 'html') && !filingsError
      "
    ></iframe>
    <div class="filing-error-container" *ngIf="filingsError">
      <div>
        <va-icon
          isFontAwesome="true"
          [name]="faInfoCircle"
          class="filing-info-icon mr-4"
        ></va-icon>
        <span class="error-text">Filings not found</span>
      </div>
    </div>
  </ng-container>
</nz-modal>
<app-column-picker-modal
  [data]="columnPickerData"
  [isModalVisible]="isColumnPickerModalVisible"
  (onDrag)="handleColumnDrag($event)"
  (onApply)="hanldeColumnPickerApplyClick($event)"
  (onReset)="handleColumnPickerResetClick()"
  (onCancel)="handleColumnPickerCancelClick()"
></app-column-picker-modal>

<app-tpr-document-modal
  *ngIf="selectedSourceId && isDocumentModalOpen"
  (modalOpenStatus)="isDocumentModalOpen = $event"
  [isModalOpen]="isDocumentModalOpen"
  [companyId]="primaryTickerCompanyId"
  [sourceId]="selectedSourceId"
  [ticker]="primaryTicker"
>
</app-tpr-document-modal>
